/*
 * File Created: Tuesday, 16th May 2023 9:18:06 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Snackbar, {SnackbarProps} from "@mui/material/Snackbar";
import React from 'react'

export type SnackBarProps = SnackbarProps

function SnackBar(props: SnackBarProps) {
  return (
    <Snackbar {...props} />
  )
}

export default SnackBar;